import type { PolygonPerimeter } from '@evimo/types';
import { getSiteAssetStatus } from '~/app/hooks/site/useSiteAssetMap';
import type { GoogleLatLngLiteral } from '~/app/lib/google-maps';

export function getPolygonCenter(
  perimeter: PolygonPerimeter,
): GoogleLatLngLiteral {
  const total = perimeter.reduce(
    (accumulator, point) => ({
      lat: accumulator.lat + point.lat,
      lng: accumulator.lng + point.lng,
    }),
    { lat: 0, lng: 0 },
  );

  return {
    lat: total.lat / perimeter.length,
    lng: total.lng / perimeter.length,
  };
}

export function getMarkerCoordinates(
  latitude: number,
  longitude: number,
  index: number,
  total: number,
): GoogleLatLngLiteral {
  if (total <= 1) {
    return { lat: latitude, lng: longitude };
  }

  const positionIndex = index % 8;
  const ringIndex = Math.floor(index / 8);
  const angle = (positionIndex / 8) * Math.PI * 2;
  const radius = 0.00028 * (ringIndex + 1);
  const longitudeFactor = Math.max(Math.cos((latitude * Math.PI) / 180), 0.2);

  return {
    lat: latitude + radius * Math.cos(angle),
    lng: longitude + (radius * Math.sin(angle)) / longitudeFactor,
  };
}

export function getMarkerColor(openIncidentsCount: number): string {
  const status = getSiteAssetStatus(openIncidentsCount);

  if (status === 'healthy') {
    return '#16a34a';
  }

  if (status === 'warning') {
    return '#f59e0b';
  }

  return '#dc2626';
}
